import { render, staticRenderFns } from "./FreelanceEdit_backup20220916.vue?vue&type=template&id=e5d8d104&scoped=true&"
import script from "./FreelanceEdit_backup20220916.vue?vue&type=script&lang=js&"
export * from "./FreelanceEdit_backup20220916.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d8d104",
  null
  
)

export default component.exports